import React from 'react';
import $ from 'jquery';
import _ from 'lodash';
import {store} from 'App/store';
import {
  setListingsLoadCompleted,
  updateListings as updateListingsAction,
  incrementFindAndReplaceRequestIndex,
  setPublishInProgress,
} from 'MyAccount/ViewDesigns/redux/modules/listingsPage';
import {
  updateListingData,
  updateCategorySiteData,
  updateSellerPolicies,
  updateRecentlyUsedCategories,
} from '../ViewDesigns/redux/modules/ebayListing';
import {wrapAjax} from 'MyAccount/ViewDesigns/helpers/preferencesHelper';
import async from 'async';
import {removeDraft, setSelectedItemIds, setEditDescription} from 'MyAccount/ViewDesigns/redux/modules/listingsPage';
import AreYouSureDialog from 'shared/components/Dialogs/AreYouSureDialog/AreYouSureDialog';
import jQueryAjaxRetry from 'shared/helpers/jQueryAjaxRetry';
import {allListingsById} from 'shared/selectors/listingsPageSelectors';
import {updateSellerStoreCategories} from 'MyAccount/ViewDesigns/redux/modules/listingsPage';
import Promise from 'bluebird';
import {isDirty, isNonDraftItemId} from 'MyAccount/Listings/EbayListing/ebayListingSelectors';
import {adjustLocationInStore} from 'shared/components/redux/connectWithRouter';
import {getPhotosInOtherNotInEbay, getPhotosUnion} from './EbayListing/ebayListingSelectors';
import {SHOW_MODES} from './EbayListing/consts';
import mem from 'mem';
const API_VER = 5;

export const QUERY_TO_ALLOW_CDN_CACHE = 'cl-allow-cache-magic-string';

export function getListingData(itemId) {
  const promise = jQueryAjaxRetry({
    method: 'GET',
    url: '/ebay/new-user/load-listing-data',
    data: {
      itemId,
    },
  });
  promise.then(result => {
    if (result.success) {
      const sellerId = _.keys(result.listings)[0];
      store.dispatch(updateListingsAction(result.listings[sellerId].listings));
    }
  });
  return promise;
}

export const refreshListing = wrapAjax((sellerId, itemId) => {
  return jQueryAjaxRetry({
    method: 'GET',
    url: '/ebay/new-user/get-listing',
    data: {itemId},
  }).then(result => {
    if (result.success) {
      store.dispatch(updateListingsAction({[itemId]: result.listing}));
    }
  });
});

export const getEbayCategorySiteData = wrapAjax(
  (categoryId, site) => {
    return jQueryAjaxRetry({
      method: 'GET',
      url: '/ebay/ebay/get-static-data',
      data: {categoryId: categoryId ? categoryId : undefined, site, [QUERY_TO_ALLOW_CDN_CACHE]: '', API_VER},
    }).then(result => {
      if (result.success) {
        store.dispatch(updateCategorySiteData(result.data));
        return result.data;
      }
    });
  },
  {windowBusy: false, abortPreviousRequests: true}
);

export function refreshListingsWithQuery(query, callback) {
  async.retry(callback => {
    $.ajax({
      method: 'GET',
      url: '/ebay/new-user/get-listings-page-listings',
      data: query,
    }).then(
      result => {
        if (result.success) {
          store.dispatch(updateListingsAction(result.listings));
          callback();
        } else {
          console.error('refreshListings invalid response', result);
          callback('Unknown error');
        }
      },
      error => {
        console.error('refreshListings error response', error);
        callback(error);
      }
    );
  }, callback);
}

export function delayedSetPublishedCompleted() {
  window.setTimeout(() => {
    store.dispatch(setPublishInProgress(false));
  }, 5 * 1000);
}

export const getEbayListingData = wrapAjax(
  ({itemId, refreshFromEbay}) => {
    return jQueryAjaxRetry({
      method: 'GET',
      url: '/ebay/ebay/get-ebay-listing-data',
      data: {itemId, refreshFromEbay, API_VER},
    }).then(result => {
      if (result.success) {
        store.dispatch(updateListingData(result.data));
        if (refreshFromEbay) {
          refreshListingsWithQuery({sellerId: result.data.clData.sellerId, itemIds: [itemId]});
        }
      }
      return result;
    });
  },
  {windowBusy: false, abortPreviousRequests: true}
);

export const getCategoryInfo = mem(
  wrapAjax(
    (categoryId, site) => {
      return jQueryAjaxRetry({
        method: 'GET',
        url: '/ebay/ebay/get-category-info',
        data: {categoryId, site, API_VER},
      });
    },
    {windowBusy: false, abortPreviousRequests: true}
  ),
  {cachePromiseRejection: false}
);

export const getSuggestedCategories = wrapAjax(
  (searchText, site) => {
    const payload = {
      method: 'GET',
      url: '/ebay/ebay/get-suggested-categories',
      data: {searchText, site, API_VER},
    };
    return jQueryAjaxRetry(payload);
  },
  {windowBusy: false, abortPreviousRequests: true}
);

export const getBrowseCategories = wrapAjax(
  (categoryId, site) => {
    const payload = {
      method: 'GET',
      url: '/ebay/ebay/get-browse-categories',
      data: {categoryId, site, [QUERY_TO_ALLOW_CDN_CACHE]: '', API_VER},
    };
    return jQueryAjaxRetry(payload);
  },
  {windowBusy: false, abortPreviousRequests: true}
);

export const getRecentlyUsedCategories = site => {
  return jQueryAjaxRetry({
    method: 'GET',
    url: '/application/user/get-recently-used-categories',
    data: {site},
  }).then(result => {
    if (result.success) {
      store.dispatch(updateRecentlyUsedCategories(result.data));
    }
  });
};

export function refreshSellerStoreCategories(sellerId, refreshFromEbay = false) {
  return jQueryAjaxRetry({
    method: 'GET',
    url: '/ebay/ebay/get-seller-store-categories',
    data: {sellerId, refreshFromEbay, API_VER},
  }).then(result => {
    if (result.success) {
      store.dispatch(updateSellerStoreCategories(sellerId, result.data));
    }
    return result.data;
  });
}

export const addRecentlyUsedCategory = (categoryId, site) => {
  $.ajax({
    method: 'POST',
    url: '/application/user/add-recently-used-category',
    data: {categoryId, site, API_VER},
  }).then(result => {
    if (result.success) {
      store.dispatch(updateRecentlyUsedCategories(result.data));
    }
  });
};

export const getSellerPolicies = (sellerId, site, refreshFromEbay) => {
  return jQueryAjaxRetry({
    method: 'GET',
    url: '/ebay/ebay/get-seller-policies',
    data: {sellerId, site, refreshFromEbay, API_VER},
  }).then(result => {
    if (result.success) {
      store.dispatch(updateSellerPolicies(result.data));
      return result.data;
    }
  });
};

const refreshingSellers = {};
export function refreshListings(sellerId, statusFilter) {
  if (_.isEmpty(sellerId) || !store.getState().user.bulkReviseEnabled) {
    return;
  }
  if (refreshingSellers[sellerId] && refreshingSellers[sellerId][statusFilter]) {
    return;
  }
  refreshingSellers[sellerId] = {...refreshingSellers[sellerId], [statusFilter]: true};
  const pageSize = 500;
  let numberOfPage = store.getState().listingsPage.listings[sellerId][statusFilter].listingsCount / pageSize + 1;
  numberOfPage = Math.min(numberOfPage, 400);
  async.parallelLimit(
    _.range(0, numberOfPage).map(page => {
      return callback => {
        refreshListingsWithQuery({sellerId, statusFilter, page, limit: pageSize}, callback);
      };
    }),
    5,
    () => {
      refreshingSellers[sellerId] = {...refreshingSellers[sellerId], [statusFilter]: false};
      store.dispatch(setListingsLoadCompleted(sellerId, statusFilter));
    }
  );
}

export const clearReviseError = wrapAjax(itemIds => {
  return $.ajax({
    method: 'POST',
    url: '/ebay/new-user/clear-revise-error',
    data: {
      itemIds,
    },
  }).then(result => {
    if (result.success) {
      store.dispatch(updateListingsAction(result.listings));
    }
  });
});

export function getListingById(itemId) {
  return allListingsById(store.getState())[itemId];
}

export const deleteDrafts = wrapAjax((sellerId, itemIds) => {
  return $.ajax({
    method: 'POST',
    url: '/ebay/new-user/delete-drafts',
    data: {
      itemIds,
      sellerId,
    },
  }).then(result => {
    if (result.success) {
      store.dispatch(removeDraft(sellerId, itemIds));
    }
  });
});

export function showDeleteDraftsDialog(sellerId, itemIds) {
  if (_.isEmpty(itemIds)) {
    return;
  }
  AreYouSureDialog.areYouSure({
    title: 'Delete draft',
    message: (
      <div>
        Are you sure you want to delete {itemIds.length === 1 ? 'this draft' : `${itemIds.length} selected drafts`}?
        <br />
        Once you delete a draft it can not be restored.
      </div>
    ),
    action: () => {
      deleteDrafts(sellerId, itemIds);
    },
    cancelButtonLabel: 'Cancel',
    actionButtonLabel: 'Delete',
  });
}

export function createDraftItemId() {
  return `DRAFT-${Math.random()
    .toString(36)
    .substring(2)
    .toUpperCase()}`;
}

let lastFind;
let lastWholeWordsOnly;
export const findAndReplace = wrapAjax(
  (sellerId, statusFilter, find, replaceWith, wholeWordsOnly, findOnly = false) => {
    if (lastFind !== find || lastWholeWordsOnly !== wholeWordsOnly) {
      store.dispatch(incrementFindAndReplaceRequestIndex());
      lastFind = find;
      lastWholeWordsOnly = wholeWordsOnly;
    }
    const requestIndex = store.getState().listingsPage.findAndReplaceRequestIndex;
    $.ajax({
      method: 'POST',
      url: '/ebay/new-user/find-and-replace',
      data: {
        sellerId,
        statusFilter,
        find,
        replaceWith,
        requestIndex,
        findOnly,
        wholeWordsOnly,
      },
    });
  }
);

export function confirmNavigation() {
  if (isDirty(adjustLocationInStore(store.getState())) && !window.confirm('Changes you made may not be saved.')) {
    return Promise.resolve('Aborted by user');
  }
  return false;
}

export function refreshFromEbay(itemId, sellerId, site) {
  const abort = confirmNavigation();
  if (abort) {
    return abort;
  }
  const promises = [getSellerPolicies(sellerId, site, true), refreshSellerStoreCategories(sellerId, true)];
  if (isNonDraftItemId(itemId)) {
    promises.push(getEbayListingData({itemId, refreshFromEbay: true}));
  }
  return Promise.all(promises);
}

export function openEditDescription(itemId) {
  store.dispatch(setEditDescription(true));
  store.dispatch(setSelectedItemIds({[itemId]: true}));
}

export function updateDescriptionPhotos(showMode, descriptionGalleryUrls, reorder, deletion, addition) {
  if (deletion) {
    return getPhotosInOtherNotInEbay(deletion, descriptionGalleryUrls);
  } else if (showMode === SHOW_MODES.SHOW_ALL && !reorder) {
    return getPhotosUnion(addition, descriptionGalleryUrls);
  }
  return descriptionGalleryUrls;
}
